import React, { useEffect, useRef, type JSX } from "react";
import { useAuth } from "../Context/AuthContext";
import { auth } from "../lib/firebase";

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading, openAuthModal } = useAuth();
  const modalOpened = useRef(false);
  const isLoggedIn = !!user;

  useEffect(() => {
    if (!loading && !isLoggedIn && !modalOpened.current) {
      const timer = setTimeout(() => {
        openAuthModal();
      }, 2000); // 2-second delay

      return () => clearTimeout(timer);
    }
  }, [user, loading, openAuthModal]);

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FFD166] mx-auto"></div>
        <p className="mt-4 text-[#5E503F]">Loading, please wait...</p>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
